import PropTypes from "prop-types";
import React, { useEffect } from "react";

const Wootric = (props) => {
  const { theme } = props;
  const newTheme = theme === "default" ? "light" : "dark";

  const init = () => {    
    const username = localStorage.getItem('username');

    let setupScript = document.createElement("script");
    setupScript.type = "text/javascript";
    setupScript.id = "wootric-settings";
    setupScript.async = true;
    setupScript.innerHTML = `
      wootric_survey_immediately = ${process.env.REACT_APP_WOOTRIC_SURVEY_IMMEDIATELY};
      window.wootricSettings = {
        email: '${username}',
        account_token: 'NPS-4fd06914',
        scale_color: 'gradient',
        modal_theme: '${newTheme}',
      };
    `;
    if (document.getElementById("wootric-settings") == null) {
      document.body.appendChild(setupScript);
    }

    // Beacon
    let beacon = document.createElement("script");
    beacon.type = "text/javascript";
    beacon.id = "wootric-beacon";
    beacon.async = true;

    beacon.src = "https://cdn.wootric.com/wootric-sdk.js";
    beacon.onload = function () {
      window.wootric("run");
    };
    if (document.getElementById("wootric-beacon") == null) {
      document.body.appendChild(beacon);
    }
  };

  useEffect(init, []);

  useEffect(() => {
    return () => {
      // clean up on unmount
      window.WootricSurvey.stop();
    };
  }, []);

  return <React.Fragment/>;
};

Wootric.propTypes = {
  theme: PropTypes.string,
};

Wootric.defaultProps = {
  theme: "light",
};

export default Wootric;
